import { Layout, Row, Col } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { ThemedImage } from '../Common/ThemedImage';
import { CloseButton } from '../Common/CloseButton';
import './index.less';
import { useFeature } from '@sendpayments/react-shared/hooks/useFeature'; // can be removed in the future
import { PD_4823_REBRANDING_2025 } from '@sendpayments/shared-constants/features'; // can be removed in the future

const { Header } = Layout;

function StepFormLayout(props) {
  const [
    {
      data: { isEnabled: isRebrandActive },
    },
  ] = useFeature({
    feature: PD_4823_REBRANDING_2025,
    activeValue: undefined,
    functionName: `Captcha`,
    defaultValue: undefined,
  });

  const ThemedImageJSX = () => {
    return isRebrandActive ? (
      <ThemedImage alt="logo" file="updated_logo.svg" path={null} />
    ) : (
      <ThemedImage alt="logo" file="logo.svg" path={null} />
    );
  };

  return (
    <Layout className={props.className}>
      <Header>
        <div className="container">
          <Row type="flex" justify="space-between" style={{ width: '100%' }}>
            <Col xl={3} lg={4} xs={6}>
              <a className="logo" href="/">
                <ThemedImageJSX />
              </a>
            </Col>

            <Col style={{ alignSelf: 'flex-end' }}>
              <Row>
                <Col>
                  <CloseButton onClick={props.onCloseClick} isRebrandActive={isRebrandActive} />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </Header>
      {props.children}
    </Layout>
  );
}

StepFormLayout.propTypes = {
  children: PropTypes.node.isRequired,
  onCloseClick: PropTypes.func,
  className: PropTypes.string,
};

StepFormLayout.defaultProps = {
  onCloseClick: undefined,
  className: undefined,
};

export default StepFormLayout;
